export interface AppConfig {
  leagueGuid: string;
  baseUrl: string;
  sportId?: number;
  isAuthenticated?: boolean;
  officialLeagueGuids?: string[];
  draftOrderPage?: boolean;
  conferenceName?: string;
  div1?: string;
  div2?: string;
  numDivisions?: number;
  numGames?: number;
  numWeeks?: number;
  emptySeasonString?: string;
  apiRoute?: string;
}

/**
 * Returns the WebApp base URL from the layout-config data attribute.
 * Set in _Layout.cshtml from ViewBag.WebAppBaseUrl (SiteDataInjector → IConfigClient).
 */
export function getWebAppBaseUrl(): string {
  return document.getElementById('layout-config')?.dataset['webappBaseUrl'] ?? 'https://playoffpredictors.com';
}

/**
 * Returns the V2 base URL from the layout-config data attribute.
 * Set in _Layout.cshtml from ViewBag.V2BaseUrl (SiteDataInjector → IConfigClient).
 */
export function getV2BaseUrl(): string {
  return document.getElementById('layout-config')?.dataset['v2BaseUrl'] ?? 'https://v2.playoffpredictors.com';
}

/**
 * Returns the APIM base URL from the layout-config data attribute.
 * Set in _Layout.cshtml from appsettings: ApimBaseUrl.
 */
export function getApimBaseUrl(): string {
  const layout = document.getElementById('layout-config');
  const url = layout?.dataset.apimBaseUrl;
  if (!url) {
    throw new Error('ApimBaseUrl not configured. Set AppSettings:ApimBaseUrl in appsettings.json.');
  }
  return url;
}

export function readConfig(): AppConfig {
  const el = document.getElementById('app-config');
  const layout = document.getElementById('layout-config');
  return {
    leagueGuid: el?.dataset.leagueGuid ?? '',
    baseUrl: layout?.dataset.baseUrl ?? '/',
    sportId: el?.dataset.sportId ? Number(el.dataset.sportId) : undefined,
    isAuthenticated: layout?.dataset.isAuthenticated === 'true',
    officialLeagueGuids: el?.dataset.officialLeagueGuids
      ? JSON.parse(el.dataset.officialLeagueGuids)
      : undefined,
    draftOrderPage: el?.dataset.draftOrderPage === 'true',
    conferenceName: el?.dataset.conferenceName,
    div1: el?.dataset.div1,
    div2: el?.dataset.div2,
    numDivisions: el?.dataset.numDivisions ? Number(el.dataset.numDivisions) : undefined,
    numGames: el?.dataset.numGames ? Number(el.dataset.numGames) : undefined,
    numWeeks: el?.dataset.numWeeks ? Number(el.dataset.numWeeks) : undefined,
    emptySeasonString: el?.dataset.emptySeasonString,
    apiRoute: el?.dataset.apiRoute,
  };
}
